// Americas
import enUSCommon from "./locales/en/common.json";
import enUSCandidatePortal from "./locales/en/candidate-portal.json";
import enUSHdAccount from "./locales/en/hiring-dashboard-account.json";
import enUSHdCandidates from "./locales/en/hiring-dashboard-candidates.json";
import enUSHdCommon from "./locales/en/hiring-dashboard-common.json";
import enUSHdDevTools from "./locales/en/hiring-dashboard-dev-tools.json";
import enUSHdFilter from "./locales/en/hiring-dashboard-filter.json";
import enUSHdInterviewers from "./locales/en/hiring-dashboard-interviewers.json";
import enUSHdInterviewerPortal from "./locales/en/hiring-dashboard-interviewer-portal.json";
import enUSHdJobs from "./locales/en/hiring-dashboard-jobs.json";
import enUSHdMetrics from "./locales/en/hiring-dashboard-metrics.json";
import enUSHdNav from "./locales/en/hiring-dashboard-nav.json";
import enUSHdSchedule from "./locales/en/hiring-dashboard-schedule.json";
import enUSHdTasks from "./locales/en/hiring-dashboard-tasks.json";
import enUSHdSettingsCandidatePortal from "./locales/en/hiring-dashboard-settings-candidate-portal.json";
import enUSHdSettingsGeneral from "./locales/en/hiring-dashboard-settings-general.json";
import enUSHdSettingsIntegrations from "./locales/en/hiring-dashboard-settings-integrations.json";
import enUSHdSettingsInterviewers from "./locales/en/hiring-dashboard-settings-interviewers.json";
import enUSHdSettingsPrivacy from "./locales/en/hiring-dashboard-settings-privacy.json";
import enUSHdSettingsScheduling from "./locales/en/hiring-dashboard-settings-scheduling.json";
import enUSHdSettingsTasks from "./locales/en/hiring-dashboard-settings-tasks.json";
import enUSHdSettingsTemplates from "./locales/en/hiring-dashboard-settings-templates.json";
import enUSHdSettingsAiOrg from "./locales/en/hiring-dashboard-settings-ai-org.json";
import enUSHdSettingsKnowledgeBases from "./locales/en/hiring-dashboard-settings-knowledge-bases.json";
import enUSHdSettingsTranslations from "./locales/en/hiring-dashboard-settings-translations.json";
import enUSHdAiAssistant from "./locales/en/hiring-dashboard-ai-assistant.json";

import es419Common from "./locales/es-419/common.json";
import es419CandidatePortal from "./locales/es-419/candidate-portal.json";
import es419HdAccount from "./locales/es-419/hiring-dashboard-account.json";
import es419HdCandidates from "./locales/es-419/hiring-dashboard-candidates.json";
import es419HdCommon from "./locales/es-419/hiring-dashboard-common.json";
import es419HdFilter from "./locales/es-419/hiring-dashboard-filter.json";
import es419HdInterviewers from "./locales/es-419/hiring-dashboard-interviewers.json";
import es419HdInterviewerPortal from "./locales/es-419/hiring-dashboard-interviewer-portal.json";
import es419HdJobs from "./locales/es-419/hiring-dashboard-jobs.json";
import es419HdMetrics from "./locales/es-419/hiring-dashboard-metrics.json";
import es419HdNav from "./locales/es-419/hiring-dashboard-nav.json";
import es419HdSchedule from "./locales/es-419/hiring-dashboard-schedule.json";
import es419HdTasks from "./locales/es-419/hiring-dashboard-tasks.json";
import es419HdSettingsCandidatePortal from "./locales/es-419/hiring-dashboard-settings-candidate-portal.json";
import es419HdSettingsGeneral from "./locales/es-419/hiring-dashboard-settings-general.json";
import es419HdSettingsIntegrations from "./locales/es-419/hiring-dashboard-settings-integrations.json";
import es419HdSettingsInterviewers from "./locales/es-419/hiring-dashboard-settings-interviewers.json";
import es419HdSettingsPrivacy from "./locales/es-419/hiring-dashboard-settings-privacy.json";
import es419HdSettingsScheduling from "./locales/es-419/hiring-dashboard-settings-scheduling.json";
import es419HdSettingsTasks from "./locales/es-419/hiring-dashboard-settings-tasks.json";
import es419HdSettingsTemplates from "./locales/es-419/hiring-dashboard-settings-templates.json";
import es419HdSettingsAiOrg from "./locales/es-419/hiring-dashboard-settings-ai-org.json";
import es419HdSettingsKnowledgeBases from "./locales/es-419/hiring-dashboard-settings-knowledge-bases.json";
import es419HdSettingsTranslations from "./locales/es-419/hiring-dashboard-settings-translations.json";
import es419HdAiAssistant from "./locales/es-419/hiring-dashboard-ai-assistant.json";

import ptBRCommon from "./locales/pt-BR/common.json";
import ptBRCandidatePortal from "./locales/pt-BR/candidate-portal.json";
import ptBRHdAccount from "./locales/pt-BR/hiring-dashboard-account.json";
import ptBRHdCandidates from "./locales/pt-BR/hiring-dashboard-candidates.json";
import ptBRHdCommon from "./locales/pt-BR/hiring-dashboard-common.json";
import ptBRHdFilter from "./locales/pt-BR/hiring-dashboard-filter.json";
import ptBRHdInterviewers from "./locales/pt-BR/hiring-dashboard-interviewers.json";
import ptBRHdInterviewerPortal from "./locales/pt-BR/hiring-dashboard-interviewer-portal.json";
import ptBRHdJobs from "./locales/pt-BR/hiring-dashboard-jobs.json";
import ptBRHdMetrics from "./locales/pt-BR/hiring-dashboard-metrics.json";
import ptBRHdNav from "./locales/pt-BR/hiring-dashboard-nav.json";
import ptBRHdSchedule from "./locales/pt-BR/hiring-dashboard-schedule.json";
import ptBRHdTasks from "./locales/pt-BR/hiring-dashboard-tasks.json";
import ptBRHdSettingsCandidatePortal from "./locales/pt-BR/hiring-dashboard-settings-candidate-portal.json";
import ptBRHdSettingsGeneral from "./locales/pt-BR/hiring-dashboard-settings-general.json";
import ptBRHdSettingsIntegrations from "./locales/pt-BR/hiring-dashboard-settings-integrations.json";
import ptBRHdSettingsInterviewers from "./locales/pt-BR/hiring-dashboard-settings-interviewers.json";
import ptBRHdSettingsPrivacy from "./locales/pt-BR/hiring-dashboard-settings-privacy.json";
import ptBRHdSettingsScheduling from "./locales/pt-BR/hiring-dashboard-settings-scheduling.json";
import ptBRHdSettingsTasks from "./locales/pt-BR/hiring-dashboard-settings-tasks.json";
import ptBRHdSettingsTemplates from "./locales/pt-BR/hiring-dashboard-settings-templates.json";
import ptBRHdSettingsAiOrg from "./locales/pt-BR/hiring-dashboard-settings-ai-org.json";
import ptBRHdSettingsKnowledgeBases from "./locales/pt-BR/hiring-dashboard-settings-knowledge-bases.json";
import ptBRHdSettingsTranslations from "./locales/pt-BR/hiring-dashboard-settings-translations.json";
import ptBRHdAiAssistant from "./locales/pt-BR/hiring-dashboard-ai-assistant.json";

import frCACommon from "./locales/fr-CA/common.json";
import frCACandidatePortal from "./locales/fr-CA/candidate-portal.json";
import frCAHdAccount from "./locales/fr-CA/hiring-dashboard-account.json";
import frCAHdCandidates from "./locales/fr-CA/hiring-dashboard-candidates.json";
import frCAHdCommon from "./locales/fr-CA/hiring-dashboard-common.json";
import frCAHdFilter from "./locales/fr-CA/hiring-dashboard-filter.json";
import frCAHdInterviewers from "./locales/fr-CA/hiring-dashboard-interviewers.json";
import frCAHdInterviewerPortal from "./locales/fr-CA/hiring-dashboard-interviewer-portal.json";
import frCAHdJobs from "./locales/fr-CA/hiring-dashboard-jobs.json";
import frCAHdMetrics from "./locales/fr-CA/hiring-dashboard-metrics.json";
import frCAHdNav from "./locales/fr-CA/hiring-dashboard-nav.json";
import frCAHdSchedule from "./locales/fr-CA/hiring-dashboard-schedule.json";
import frCAHdTasks from "./locales/fr-CA/hiring-dashboard-tasks.json";
import frCAHdSettingsCandidatePortal from "./locales/fr-CA/hiring-dashboard-settings-candidate-portal.json";
import frCAHdSettingsGeneral from "./locales/fr-CA/hiring-dashboard-settings-general.json";
import frCAHdSettingsIntegrations from "./locales/fr-CA/hiring-dashboard-settings-integrations.json";
import frCAHdSettingsInterviewers from "./locales/fr-CA/hiring-dashboard-settings-interviewers.json";
import frCAHdSettingsPrivacy from "./locales/fr-CA/hiring-dashboard-settings-privacy.json";
import frCAHdSettingsScheduling from "./locales/fr-CA/hiring-dashboard-settings-scheduling.json";
import frCAHdSettingsTasks from "./locales/fr-CA/hiring-dashboard-settings-tasks.json";
import frCAHdSettingsTemplates from "./locales/fr-CA/hiring-dashboard-settings-templates.json";
import frCAHdSettingsAiOrg from "./locales/fr-CA/hiring-dashboard-settings-ai-org.json";
import frCAHdSettingsKnowledgeBases from "./locales/fr-CA/hiring-dashboard-settings-knowledge-bases.json";
import frCAHdSettingsTranslations from "./locales/fr-CA/hiring-dashboard-settings-translations.json";
import frCAHdAiAssistant from "./locales/fr-CA/hiring-dashboard-ai-assistant.json";

// Europe
import enGBCommon from "./locales/en-GB/common.json";
import enGBCandidatePortal from "./locales/en-GB/candidate-portal.json";
import enGBHdAccount from "./locales/en-GB/hiring-dashboard-account.json";
import enGBHdCandidates from "./locales/en-GB/hiring-dashboard-candidates.json";
import enGBHdCommon from "./locales/en-GB/hiring-dashboard-common.json";
import enGBHdFilter from "./locales/en-GB/hiring-dashboard-filter.json";
import enGBHdInterviewers from "./locales/en-GB/hiring-dashboard-interviewers.json";
import enGBHdInterviewerPortal from "./locales/en-GB/hiring-dashboard-interviewer-portal.json";
import enGBHdJobs from "./locales/en-GB/hiring-dashboard-jobs.json";
import enGBHdMetrics from "./locales/en-GB/hiring-dashboard-metrics.json";
import enGBHdNav from "./locales/en-GB/hiring-dashboard-nav.json";
import enGBHdSchedule from "./locales/en-GB/hiring-dashboard-schedule.json";
import enGBHdTasks from "./locales/en-GB/hiring-dashboard-tasks.json";
import enGBHdSettingsCandidatePortal from "./locales/en-GB/hiring-dashboard-settings-candidate-portal.json";
import enGBHdSettingsGeneral from "./locales/en-GB/hiring-dashboard-settings-general.json";
import enGBHdSettingsIntegrations from "./locales/en-GB/hiring-dashboard-settings-integrations.json";
import enGBHdSettingsInterviewers from "./locales/en-GB/hiring-dashboard-settings-interviewers.json";
import enGBHdSettingsPrivacy from "./locales/en-GB/hiring-dashboard-settings-privacy.json";
import enGBHdSettingsScheduling from "./locales/en-GB/hiring-dashboard-settings-scheduling.json";
import enGBHdSettingsTasks from "./locales/en-GB/hiring-dashboard-settings-tasks.json";
import enGBHdSettingsTemplates from "./locales/en-GB/hiring-dashboard-settings-templates.json";
import enGBHdSettingsAiOrg from "./locales/en-GB/hiring-dashboard-settings-ai-org.json";
import enGBHdSettingsKnowledgeBases from "./locales/en-GB/hiring-dashboard-settings-knowledge-bases.json";
import enGBHdSettingsTranslations from "./locales/en-GB/hiring-dashboard-settings-translations.json";
import enGBHdAiAssistant from "./locales/en-GB/hiring-dashboard-ai-assistant.json";

import frCommon from "./locales/fr/common.json";
import frCandidatePortal from "./locales/fr/candidate-portal.json";
import frHdAccount from "./locales/fr/hiring-dashboard-account.json";
import frHdCandidates from "./locales/fr/hiring-dashboard-candidates.json";
import frHdCommon from "./locales/fr/hiring-dashboard-common.json";
import frHdFilter from "./locales/fr/hiring-dashboard-filter.json";
import frHdInterviewers from "./locales/fr/hiring-dashboard-interviewers.json";
import frHdInterviewerPortal from "./locales/fr/hiring-dashboard-interviewer-portal.json";
import frHdJobs from "./locales/fr/hiring-dashboard-jobs.json";
import frHdMetrics from "./locales/fr/hiring-dashboard-metrics.json";
import frHdNav from "./locales/fr/hiring-dashboard-nav.json";
import frHdSchedule from "./locales/fr/hiring-dashboard-schedule.json";
import frHdTasks from "./locales/fr/hiring-dashboard-tasks.json";
import frHdSettingsCandidatePortal from "./locales/fr/hiring-dashboard-settings-candidate-portal.json";
import frHdSettingsGeneral from "./locales/fr/hiring-dashboard-settings-general.json";
import frHdSettingsIntegrations from "./locales/fr/hiring-dashboard-settings-integrations.json";
import frHdSettingsInterviewers from "./locales/fr/hiring-dashboard-settings-interviewers.json";
import frHdSettingsPrivacy from "./locales/fr/hiring-dashboard-settings-privacy.json";
import frHdSettingsScheduling from "./locales/fr/hiring-dashboard-settings-scheduling.json";
import frHdSettingsTasks from "./locales/fr/hiring-dashboard-settings-tasks.json";
import frHdSettingsTemplates from "./locales/fr/hiring-dashboard-settings-templates.json";
import frHdSettingsAiOrg from "./locales/fr/hiring-dashboard-settings-ai-org.json";
import frHdSettingsKnowledgeBases from "./locales/fr/hiring-dashboard-settings-knowledge-bases.json";
import frHdSettingsTranslations from "./locales/fr/hiring-dashboard-settings-translations.json";
import frHdAiAssistant from "./locales/fr/hiring-dashboard-ai-assistant.json";

import esCommon from "./locales/es/common.json";
import esCandidatePortal from "./locales/es/candidate-portal.json";
import esHdAccount from "./locales/es/hiring-dashboard-account.json";
import esHdCandidates from "./locales/es/hiring-dashboard-candidates.json";
import esHdCommon from "./locales/es/hiring-dashboard-common.json";
import esHdFilter from "./locales/es/hiring-dashboard-filter.json";
import esHdInterviewers from "./locales/es/hiring-dashboard-interviewers.json";
import esHdInterviewerPortal from "./locales/es/hiring-dashboard-interviewer-portal.json";
import esHdJobs from "./locales/es/hiring-dashboard-jobs.json";
import esHdMetrics from "./locales/es/hiring-dashboard-metrics.json";
import esHdNav from "./locales/es/hiring-dashboard-nav.json";
import esHdSchedule from "./locales/es/hiring-dashboard-schedule.json";
import esHdTasks from "./locales/es/hiring-dashboard-tasks.json";
import esHdSettingsCandidatePortal from "./locales/es/hiring-dashboard-settings-candidate-portal.json";
import esHdSettingsGeneral from "./locales/es/hiring-dashboard-settings-general.json";
import esHdSettingsIntegrations from "./locales/es/hiring-dashboard-settings-integrations.json";
import esHdSettingsInterviewers from "./locales/es/hiring-dashboard-settings-interviewers.json";
import esHdSettingsPrivacy from "./locales/es/hiring-dashboard-settings-privacy.json";
import esHdSettingsScheduling from "./locales/es/hiring-dashboard-settings-scheduling.json";
import esHdSettingsTasks from "./locales/es/hiring-dashboard-settings-tasks.json";
import esHdSettingsTemplates from "./locales/es/hiring-dashboard-settings-templates.json";
import esHdSettingsAiOrg from "./locales/es/hiring-dashboard-settings-ai-org.json";
import esHdSettingsKnowledgeBases from "./locales/es/hiring-dashboard-settings-knowledge-bases.json";
import esHdSettingsTranslations from "./locales/es/hiring-dashboard-settings-translations.json";
import esHdAiAssistant from "./locales/es/hiring-dashboard-ai-assistant.json";

import deCommon from "./locales/de-DE/common.json";
import deCandidatePortal from "./locales/de-DE/candidate-portal.json";
import deHdAccount from "./locales/de-DE/hiring-dashboard-account.json";
import deHdCandidates from "./locales/de-DE/hiring-dashboard-candidates.json";
import deHdCommon from "./locales/de-DE/hiring-dashboard-common.json";
import deHdFilter from "./locales/de-DE/hiring-dashboard-filter.json";
import deHdInterviewers from "./locales/de-DE/hiring-dashboard-interviewers.json";
import deHdInterviewerPortal from "./locales/de-DE/hiring-dashboard-interviewer-portal.json";
import deHdJobs from "./locales/de-DE/hiring-dashboard-jobs.json";
import deHdMetrics from "./locales/de-DE/hiring-dashboard-metrics.json";
import deHdNav from "./locales/de-DE/hiring-dashboard-nav.json";
import deHdSchedule from "./locales/de-DE/hiring-dashboard-schedule.json";
import deHdTasks from "./locales/de-DE/hiring-dashboard-tasks.json";
import deHdSettingsCandidatePortal from "./locales/de-DE/hiring-dashboard-settings-candidate-portal.json";
import deHdSettingsGeneral from "./locales/de-DE/hiring-dashboard-settings-general.json";
import deHdSettingsIntegrations from "./locales/de-DE/hiring-dashboard-settings-integrations.json";
import deHdSettingsInterviewers from "./locales/de-DE/hiring-dashboard-settings-interviewers.json";
import deHdSettingsPrivacy from "./locales/de-DE/hiring-dashboard-settings-privacy.json";
import deHdSettingsScheduling from "./locales/de-DE/hiring-dashboard-settings-scheduling.json";
import deHdSettingsTasks from "./locales/de-DE/hiring-dashboard-settings-tasks.json";
import deHdSettingsTemplates from "./locales/de-DE/hiring-dashboard-settings-templates.json";
import deHdSettingsAiOrg from "./locales/de-DE/hiring-dashboard-settings-ai-org.json";
import deHdSettingsKnowledgeBases from "./locales/de-DE/hiring-dashboard-settings-knowledge-bases.json";
import deHdSettingsTranslations from "./locales/de-DE/hiring-dashboard-settings-translations.json";
import deHdAiAssistant from "./locales/de-DE/hiring-dashboard-ai-assistant.json";

import daDKCommon from "./locales/da-DK/common.json";
import daDKCandidatePortal from "./locales/da-DK/candidate-portal.json";
import daDKHdAccount from "./locales/da-DK/hiring-dashboard-account.json";
import daDKHdCandidates from "./locales/da-DK/hiring-dashboard-candidates.json";
import daDKHdCommon from "./locales/da-DK/hiring-dashboard-common.json";
import daDKHdFilter from "./locales/da-DK/hiring-dashboard-filter.json";
import daDKHdInterviewers from "./locales/da-DK/hiring-dashboard-interviewers.json";
import daDKHdInterviewerPortal from "./locales/da-DK/hiring-dashboard-interviewer-portal.json";
import daDKHdJobs from "./locales/da-DK/hiring-dashboard-jobs.json";
import daDKHdMetrics from "./locales/da-DK/hiring-dashboard-metrics.json";
import daDKHdNav from "./locales/da-DK/hiring-dashboard-nav.json";
import daDKHdSchedule from "./locales/da-DK/hiring-dashboard-schedule.json";
import daDKHdTasks from "./locales/da-DK/hiring-dashboard-tasks.json";
import daDKHdSettingsCandidatePortal from "./locales/da-DK/hiring-dashboard-settings-candidate-portal.json";
import daDKHdSettingsGeneral from "./locales/da-DK/hiring-dashboard-settings-general.json";
import daDKHdSettingsIntegrations from "./locales/da-DK/hiring-dashboard-settings-integrations.json";
import daDKHdSettingsInterviewers from "./locales/da-DK/hiring-dashboard-settings-interviewers.json";
import daDKHdSettingsPrivacy from "./locales/da-DK/hiring-dashboard-settings-privacy.json";
import daDKHdSettingsScheduling from "./locales/da-DK/hiring-dashboard-settings-scheduling.json";
import daDKHdSettingsTasks from "./locales/da-DK/hiring-dashboard-settings-tasks.json";
import daDKHdSettingsTemplates from "./locales/da-DK/hiring-dashboard-settings-templates.json";
import daDKHdSettingsAiOrg from "./locales/da-DK/hiring-dashboard-settings-ai-org.json";
import daDKHdSettingsKnowledgeBases from "./locales/da-DK/hiring-dashboard-settings-knowledge-bases.json";
import daDKHdSettingsTranslations from "./locales/da-DK/hiring-dashboard-settings-translations.json";
import daDKHdAiAssistant from "./locales/da-DK/hiring-dashboard-ai-assistant.json";

import itCommon from "./locales/it-IT/common.json";
import itCandidatePortal from "./locales/it-IT/candidate-portal.json";
import itHdAccount from "./locales/it-IT/hiring-dashboard-account.json";
import itHdCandidates from "./locales/it-IT/hiring-dashboard-candidates.json";
import itHdCommon from "./locales/it-IT/hiring-dashboard-common.json";
import itHdFilter from "./locales/it-IT/hiring-dashboard-filter.json";
import itHdInterviewers from "./locales/it-IT/hiring-dashboard-interviewers.json";
import itHdInterviewerPortal from "./locales/it-IT/hiring-dashboard-interviewer-portal.json";
import itHdJobs from "./locales/it-IT/hiring-dashboard-jobs.json";
import itHdMetrics from "./locales/it-IT/hiring-dashboard-metrics.json";
import itHdNav from "./locales/it-IT/hiring-dashboard-nav.json";
import itHdSchedule from "./locales/it-IT/hiring-dashboard-schedule.json";
import itHdTasks from "./locales/it-IT/hiring-dashboard-tasks.json";
import itHdSettingsCandidatePortal from "./locales/it-IT/hiring-dashboard-settings-candidate-portal.json";
import itHdSettingsGeneral from "./locales/it-IT/hiring-dashboard-settings-general.json";
import itHdSettingsIntegrations from "./locales/it-IT/hiring-dashboard-settings-integrations.json";
import itHdSettingsInterviewers from "./locales/it-IT/hiring-dashboard-settings-interviewers.json";
import itHdSettingsPrivacy from "./locales/it-IT/hiring-dashboard-settings-privacy.json";
import itHdSettingsScheduling from "./locales/it-IT/hiring-dashboard-settings-scheduling.json";
import itHdSettingsTasks from "./locales/it-IT/hiring-dashboard-settings-tasks.json";
import itHdSettingsTemplates from "./locales/it-IT/hiring-dashboard-settings-templates.json";
import itHdSettingsAiOrg from "./locales/it-IT/hiring-dashboard-settings-ai-org.json";
import itHdSettingsKnowledgeBases from "./locales/it-IT/hiring-dashboard-settings-knowledge-bases.json";
import itHdSettingsTranslations from "./locales/it-IT/hiring-dashboard-settings-translations.json";
import itHdAiAssistant from "./locales/it-IT/hiring-dashboard-ai-assistant.json";

// Asia
import jaCommon from "./locales/ja-JP/common.json";
import jaCandidatePortal from "./locales/ja-JP/candidate-portal.json";
import jaHdAccount from "./locales/ja-JP/hiring-dashboard-account.json";
import jaHdCandidates from "./locales/ja-JP/hiring-dashboard-candidates.json";
import jaHdCommon from "./locales/ja-JP/hiring-dashboard-common.json";
import jaHdFilter from "./locales/ja-JP/hiring-dashboard-filter.json";
import jaHdInterviewers from "./locales/ja-JP/hiring-dashboard-interviewers.json";
import jaHdInterviewerPortal from "./locales/ja-JP/hiring-dashboard-interviewer-portal.json";
import jaHdJobs from "./locales/ja-JP/hiring-dashboard-jobs.json";
import jaHdMetrics from "./locales/ja-JP/hiring-dashboard-metrics.json";
import jaHdNav from "./locales/ja-JP/hiring-dashboard-nav.json";
import jaHdSchedule from "./locales/ja-JP/hiring-dashboard-schedule.json";
import jaHdTasks from "./locales/ja-JP/hiring-dashboard-tasks.json";
import jaHdSettingsCandidatePortal from "./locales/ja-JP/hiring-dashboard-settings-candidate-portal.json";
import jaHdSettingsGeneral from "./locales/ja-JP/hiring-dashboard-settings-general.json";
import jaHdSettingsIntegrations from "./locales/ja-JP/hiring-dashboard-settings-integrations.json";
import jaHdSettingsInterviewers from "./locales/ja-JP/hiring-dashboard-settings-interviewers.json";
import jaHdSettingsPrivacy from "./locales/ja-JP/hiring-dashboard-settings-privacy.json";
import jaHdSettingsScheduling from "./locales/ja-JP/hiring-dashboard-settings-scheduling.json";
import jaHdSettingsTasks from "./locales/ja-JP/hiring-dashboard-settings-tasks.json";
import jaHdSettingsTemplates from "./locales/ja-JP/hiring-dashboard-settings-templates.json";
import jaHdSettingsAiOrg from "./locales/ja-JP/hiring-dashboard-settings-ai-org.json";
import jaHdSettingsKnowledgeBases from "./locales/ja-JP/hiring-dashboard-settings-knowledge-bases.json";
import jaHdSettingsTranslations from "./locales/ja-JP/hiring-dashboard-settings-translations.json";
import jaHdAiAssistant from "./locales/ja-JP/hiring-dashboard-ai-assistant.json";

import koCommon from "./locales/ko/common.json";
import koCandidatePortal from "./locales/ko/candidate-portal.json";
import koHdAccount from "./locales/ko/hiring-dashboard-account.json";
import koHdCandidates from "./locales/ko/hiring-dashboard-candidates.json";
import koHdCommon from "./locales/ko/hiring-dashboard-common.json";
import koHdFilter from "./locales/ko/hiring-dashboard-filter.json";
import koHdInterviewers from "./locales/ko/hiring-dashboard-interviewers.json";
import koHdInterviewerPortal from "./locales/ko/hiring-dashboard-interviewer-portal.json";
import koHdJobs from "./locales/ko/hiring-dashboard-jobs.json";
import koHdMetrics from "./locales/ko/hiring-dashboard-metrics.json";
import koHdNav from "./locales/ko/hiring-dashboard-nav.json";
import koHdSchedule from "./locales/ko/hiring-dashboard-schedule.json";
import koHdTasks from "./locales/ko/hiring-dashboard-tasks.json";
import koHdSettingsCandidatePortal from "./locales/ko/hiring-dashboard-settings-candidate-portal.json";
import koHdSettingsGeneral from "./locales/ko/hiring-dashboard-settings-general.json";
import koHdSettingsIntegrations from "./locales/ko/hiring-dashboard-settings-integrations.json";
import koHdSettingsInterviewers from "./locales/ko/hiring-dashboard-settings-interviewers.json";
import koHdSettingsPrivacy from "./locales/ko/hiring-dashboard-settings-privacy.json";
import koHdSettingsScheduling from "./locales/ko/hiring-dashboard-settings-scheduling.json";
import koHdSettingsTasks from "./locales/ko/hiring-dashboard-settings-tasks.json";
import koHdSettingsTemplates from "./locales/ko/hiring-dashboard-settings-templates.json";
import koHdSettingsAiOrg from "./locales/ko/hiring-dashboard-settings-ai-org.json";
import koHdSettingsKnowledgeBases from "./locales/ko/hiring-dashboard-settings-knowledge-bases.json";
import koHdSettingsTranslations from "./locales/ko/hiring-dashboard-settings-translations.json";
import koHdAiAssistant from "./locales/ko/hiring-dashboard-ai-assistant.json";

import zhTWCommon from "./locales/zh-TW/common.json";
import zhTWCandidatePortal from "./locales/zh-TW/candidate-portal.json";
import zhTWHdAccount from "./locales/zh-TW/hiring-dashboard-account.json";
import zhTWHdCandidates from "./locales/zh-TW/hiring-dashboard-candidates.json";
import zhTWHdCommon from "./locales/zh-TW/hiring-dashboard-common.json";
import zhTWHdFilter from "./locales/zh-TW/hiring-dashboard-filter.json";
import zhTWHdInterviewers from "./locales/zh-TW/hiring-dashboard-interviewers.json";
import zhTWHdInterviewerPortal from "./locales/zh-TW/hiring-dashboard-interviewer-portal.json";
import zhTWHdJobs from "./locales/zh-TW/hiring-dashboard-jobs.json";
import zhTWHdMetrics from "./locales/zh-TW/hiring-dashboard-metrics.json";
import zhTWHdNav from "./locales/zh-TW/hiring-dashboard-nav.json";
import zhTWHdSchedule from "./locales/zh-TW/hiring-dashboard-schedule.json";
import zhTWHdTasks from "./locales/zh-TW/hiring-dashboard-tasks.json";
import zhTWHdSettingsCandidatePortal from "./locales/zh-TW/hiring-dashboard-settings-candidate-portal.json";
import zhTWHdSettingsGeneral from "./locales/zh-TW/hiring-dashboard-settings-general.json";
import zhTWHdSettingsIntegrations from "./locales/zh-TW/hiring-dashboard-settings-integrations.json";
import zhTWHdSettingsInterviewers from "./locales/zh-TW/hiring-dashboard-settings-interviewers.json";
import zhTWHdSettingsPrivacy from "./locales/zh-TW/hiring-dashboard-settings-privacy.json";
import zhTWHdSettingsScheduling from "./locales/zh-TW/hiring-dashboard-settings-scheduling.json";
import zhTWHdSettingsTasks from "./locales/zh-TW/hiring-dashboard-settings-tasks.json";
import zhTWHdSettingsTemplates from "./locales/zh-TW/hiring-dashboard-settings-templates.json";
import zhTWHdSettingsAiOrg from "./locales/zh-TW/hiring-dashboard-settings-ai-org.json";
import zhTWHdSettingsKnowledgeBases from "./locales/zh-TW/hiring-dashboard-settings-knowledge-bases.json";
import zhTWHdSettingsTranslations from "./locales/zh-TW/hiring-dashboard-settings-translations.json";
import zhTWHdAiAssistant from "./locales/zh-TW/hiring-dashboard-ai-assistant.json";

import zhCNCommon from "./locales/zh-CN/common.json";
import zhCNCandidatePortal from "./locales/zh-CN/candidate-portal.json";
import zhCNHdAccount from "./locales/zh-CN/hiring-dashboard-account.json";
import zhCNHdCandidates from "./locales/zh-CN/hiring-dashboard-candidates.json";
import zhCNHdCommon from "./locales/zh-CN/hiring-dashboard-common.json";
import zhCNHdFilter from "./locales/zh-CN/hiring-dashboard-filter.json";
import zhCNHdInterviewers from "./locales/zh-CN/hiring-dashboard-interviewers.json";
import zhCNHdInterviewerPortal from "./locales/zh-CN/hiring-dashboard-interviewer-portal.json";
import zhCNHdJobs from "./locales/zh-CN/hiring-dashboard-jobs.json";
import zhCNHdMetrics from "./locales/zh-CN/hiring-dashboard-metrics.json";
import zhCNHdNav from "./locales/zh-CN/hiring-dashboard-nav.json";
import zhCNHdSchedule from "./locales/zh-CN/hiring-dashboard-schedule.json";
import zhCNHdTasks from "./locales/zh-CN/hiring-dashboard-tasks.json";
import zhCNHdSettingsCandidatePortal from "./locales/zh-CN/hiring-dashboard-settings-candidate-portal.json";
import zhCNHdSettingsGeneral from "./locales/zh-CN/hiring-dashboard-settings-general.json";
import zhCNHdSettingsIntegrations from "./locales/zh-CN/hiring-dashboard-settings-integrations.json";
import zhCNHdSettingsInterviewers from "./locales/zh-CN/hiring-dashboard-settings-interviewers.json";
import zhCNHdSettingsPrivacy from "./locales/zh-CN/hiring-dashboard-settings-privacy.json";
import zhCNHdSettingsScheduling from "./locales/zh-CN/hiring-dashboard-settings-scheduling.json";
import zhCNHdSettingsTasks from "./locales/zh-CN/hiring-dashboard-settings-tasks.json";
import zhCNHdSettingsTemplates from "./locales/zh-CN/hiring-dashboard-settings-templates.json";
import zhCNHdSettingsAiOrg from "./locales/zh-CN/hiring-dashboard-settings-ai-org.json";
import zhCNHdSettingsKnowledgeBases from "./locales/zh-CN/hiring-dashboard-settings-knowledge-bases.json";
import zhCNHdSettingsTranslations from "./locales/zh-CN/hiring-dashboard-settings-translations.json";
import zhCNHdAiAssistant from "./locales/zh-CN/hiring-dashboard-ai-assistant.json";

/**
 * `en-sloth` is a computed test locale that stretches vowels in English strings.
 * If a string appears in normal English (not stretched), the translation key is broken.
 * Generated at import time from en-US resources — no static JSON files needed.
 */
const VOWELS = new Set("aeiouAEIOU");

function slothify(str: string): string {
  let result = "";
  let i = 0;
  while (i < str.length) {
    // Skip interpolation blocks {{ ... }}
    if (str[i] === "{" && str[i + 1] === "{") {
      const end = str.indexOf("}}", i);
      if (end !== -1) {
        result += str.slice(i, end + 2);
        i = end + 2;
        continue;
      }
    }
    // Skip HTML-like tags < ... >
    if (str[i] === "<") {
      const end = str.indexOf(">", i);
      if (end !== -1) {
        result += str.slice(i, end + 1);
        i = end + 1;
        continue;
      }
    }
    // Stretch vowels
    if (VOWELS.has(str[i])) {
      result += str[i].repeat(10);
    } else {
      result += str[i];
    }
    i++;
  }
  return result;
}

type NamespaceResource = Record<string, string>;
const languageNameCatalog = <T extends Record<SupportedLanguage, string>>(
  names: T,
): Record<SupportedLanguage, string> => names;

const slothifyNamespace = (ns: NamespaceResource) => {
  const out: NamespaceResource = {};
  for (const [k, v] of Object.entries(ns)) {
    out[k] = slothify(v);
  }
  return out;
};

export const namespaces = [
  "common",
  "candidate-portal",
  "hiring-dashboard-account",
  "hiring-dashboard-candidates",
  "hiring-dashboard-common",
  "hiring-dashboard-dev-tools",
  "hiring-dashboard-filter",
  "hiring-dashboard-interviewer-portal",
  "hiring-dashboard-interviewers",
  "hiring-dashboard-jobs",
  "hiring-dashboard-metrics",
  "hiring-dashboard-nav",
  "hiring-dashboard-schedule",
  "hiring-dashboard-tasks",
  "hiring-dashboard-settings-candidate-portal",
  "hiring-dashboard-settings-general",
  "hiring-dashboard-settings-integrations",
  "hiring-dashboard-settings-interviewers",
  "hiring-dashboard-settings-privacy",
  "hiring-dashboard-settings-scheduling",
  "hiring-dashboard-settings-tasks",
  "hiring-dashboard-settings-templates",
  "hiring-dashboard-settings-ai-org",
  "hiring-dashboard-settings-knowledge-bases",
  "hiring-dashboard-settings-translations",
  "hiring-dashboard-ai-assistant",
] as const;

export type Namespace = (typeof namespaces)[number];

export const supportedLanguages = [
  // Americas
  "en-US",
  "es-419",
  "pt-BR",
  "fr-CA",
  // Europe
  "en-GB",
  "fr-FR",
  "es-ES",
  "de-DE",
  "da-DK",
  "it-IT",
  // Asia
  "ja-JP",
  "ko-KR",
  "zh-TW",
  "zh-CN",
  // Fun
  "en-sloth",
] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];

export const languageNames = languageNameCatalog({
  // Americas
  "en-US": "English (US)",
  "es-419": "Español (Latinoamérica)",
  "pt-BR": "Português (Brasil)",
  "fr-CA": "Français (Canada)",
  // Europe
  "en-GB": "English (UK)",
  "fr-FR": "Français (France)",
  "es-ES": "Español (España)",
  "de-DE": "Deutsch",
  "da-DK": "Dansk",
  "it-IT": "Italiano",
  // Asia
  "ja-JP": "日本語",
  "ko-KR": "한국어",
  "zh-TW": "繁體中文",
  "zh-CN": "简体中文",
  // Fun
  "en-sloth": "Sloth",
});

export const defaultLanguage: SupportedLanguage = "en-US";
export const defaultNS: Namespace = "common";

/** i18next resources. Each namespace maps to its own flat JSON file. */
type LocaleResources = Partial<Record<Namespace, NamespaceResource>>;
type Resources = Record<SupportedLanguage, LocaleResources>;
const resourceCatalog = <T extends Resources>(catalog: T): Resources => catalog;

export const resources = resourceCatalog({
  // Americas
  "en-US": {
    common: enUSCommon,
    "candidate-portal": enUSCandidatePortal,
    "hiring-dashboard-account": enUSHdAccount,
    "hiring-dashboard-candidates": enUSHdCandidates,
    "hiring-dashboard-common": enUSHdCommon,
    "hiring-dashboard-dev-tools": enUSHdDevTools,
    "hiring-dashboard-filter": enUSHdFilter,
    "hiring-dashboard-interviewer-portal": enUSHdInterviewerPortal,
    "hiring-dashboard-interviewers": enUSHdInterviewers,
    "hiring-dashboard-jobs": enUSHdJobs,
    "hiring-dashboard-metrics": enUSHdMetrics,
    "hiring-dashboard-nav": enUSHdNav,
    "hiring-dashboard-schedule": enUSHdSchedule,
    "hiring-dashboard-tasks": enUSHdTasks,
    "hiring-dashboard-settings-candidate-portal": enUSHdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": enUSHdSettingsGeneral,
    "hiring-dashboard-settings-integrations": enUSHdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": enUSHdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": enUSHdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": enUSHdSettingsScheduling,
    "hiring-dashboard-settings-tasks": enUSHdSettingsTasks,
    "hiring-dashboard-settings-templates": enUSHdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": enUSHdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": enUSHdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": enUSHdSettingsTranslations,
    "hiring-dashboard-ai-assistant": enUSHdAiAssistant,
  },
  "es-419": {
    common: es419Common,
    "candidate-portal": es419CandidatePortal,
    "hiring-dashboard-account": es419HdAccount,
    "hiring-dashboard-candidates": es419HdCandidates,
    "hiring-dashboard-common": es419HdCommon,
    "hiring-dashboard-filter": es419HdFilter,
    "hiring-dashboard-interviewer-portal": es419HdInterviewerPortal,
    "hiring-dashboard-interviewers": es419HdInterviewers,
    "hiring-dashboard-jobs": es419HdJobs,
    "hiring-dashboard-metrics": es419HdMetrics,
    "hiring-dashboard-nav": es419HdNav,
    "hiring-dashboard-schedule": es419HdSchedule,
    "hiring-dashboard-tasks": es419HdTasks,
    "hiring-dashboard-settings-candidate-portal": es419HdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": es419HdSettingsGeneral,
    "hiring-dashboard-settings-integrations": es419HdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": es419HdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": es419HdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": es419HdSettingsScheduling,
    "hiring-dashboard-settings-tasks": es419HdSettingsTasks,
    "hiring-dashboard-settings-templates": es419HdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": es419HdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": es419HdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": es419HdSettingsTranslations,
    "hiring-dashboard-ai-assistant": es419HdAiAssistant,
  },
  "pt-BR": {
    common: ptBRCommon,
    "candidate-portal": ptBRCandidatePortal,
    "hiring-dashboard-account": ptBRHdAccount,
    "hiring-dashboard-candidates": ptBRHdCandidates,
    "hiring-dashboard-common": ptBRHdCommon,
    "hiring-dashboard-filter": ptBRHdFilter,
    "hiring-dashboard-interviewer-portal": ptBRHdInterviewerPortal,
    "hiring-dashboard-interviewers": ptBRHdInterviewers,
    "hiring-dashboard-jobs": ptBRHdJobs,
    "hiring-dashboard-metrics": ptBRHdMetrics,
    "hiring-dashboard-nav": ptBRHdNav,
    "hiring-dashboard-schedule": ptBRHdSchedule,
    "hiring-dashboard-tasks": ptBRHdTasks,
    "hiring-dashboard-settings-candidate-portal": ptBRHdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": ptBRHdSettingsGeneral,
    "hiring-dashboard-settings-integrations": ptBRHdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": ptBRHdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": ptBRHdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": ptBRHdSettingsScheduling,
    "hiring-dashboard-settings-tasks": ptBRHdSettingsTasks,
    "hiring-dashboard-settings-templates": ptBRHdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": ptBRHdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": ptBRHdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": ptBRHdSettingsTranslations,
    "hiring-dashboard-ai-assistant": ptBRHdAiAssistant,
  },
  "fr-CA": {
    common: frCACommon,
    "candidate-portal": frCACandidatePortal,
    "hiring-dashboard-account": frCAHdAccount,
    "hiring-dashboard-candidates": frCAHdCandidates,
    "hiring-dashboard-common": frCAHdCommon,
    "hiring-dashboard-filter": frCAHdFilter,
    "hiring-dashboard-interviewer-portal": frCAHdInterviewerPortal,
    "hiring-dashboard-interviewers": frCAHdInterviewers,
    "hiring-dashboard-jobs": frCAHdJobs,
    "hiring-dashboard-metrics": frCAHdMetrics,
    "hiring-dashboard-nav": frCAHdNav,
    "hiring-dashboard-schedule": frCAHdSchedule,
    "hiring-dashboard-tasks": frCAHdTasks,
    "hiring-dashboard-settings-candidate-portal": frCAHdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": frCAHdSettingsGeneral,
    "hiring-dashboard-settings-integrations": frCAHdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": frCAHdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": frCAHdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": frCAHdSettingsScheduling,
    "hiring-dashboard-settings-tasks": frCAHdSettingsTasks,
    "hiring-dashboard-settings-templates": frCAHdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": frCAHdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": frCAHdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": frCAHdSettingsTranslations,
    "hiring-dashboard-ai-assistant": frCAHdAiAssistant,
  },
  // Europe
  "en-GB": {
    common: enGBCommon,
    "candidate-portal": enGBCandidatePortal,
    "hiring-dashboard-account": enGBHdAccount,
    "hiring-dashboard-candidates": enGBHdCandidates,
    "hiring-dashboard-common": enGBHdCommon,
    "hiring-dashboard-filter": enGBHdFilter,
    "hiring-dashboard-interviewer-portal": enGBHdInterviewerPortal,
    "hiring-dashboard-interviewers": enGBHdInterviewers,
    "hiring-dashboard-jobs": enGBHdJobs,
    "hiring-dashboard-metrics": enGBHdMetrics,
    "hiring-dashboard-nav": enGBHdNav,
    "hiring-dashboard-schedule": enGBHdSchedule,
    "hiring-dashboard-tasks": enGBHdTasks,
    "hiring-dashboard-settings-candidate-portal": enGBHdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": enGBHdSettingsGeneral,
    "hiring-dashboard-settings-integrations": enGBHdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": enGBHdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": enGBHdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": enGBHdSettingsScheduling,
    "hiring-dashboard-settings-tasks": enGBHdSettingsTasks,
    "hiring-dashboard-settings-templates": enGBHdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": enGBHdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": enGBHdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": enGBHdSettingsTranslations,
    "hiring-dashboard-ai-assistant": enGBHdAiAssistant,
  },
  "fr-FR": {
    common: frCommon,
    "candidate-portal": frCandidatePortal,
    "hiring-dashboard-account": frHdAccount,
    "hiring-dashboard-candidates": frHdCandidates,
    "hiring-dashboard-common": frHdCommon,
    "hiring-dashboard-filter": frHdFilter,
    "hiring-dashboard-interviewer-portal": frHdInterviewerPortal,
    "hiring-dashboard-interviewers": frHdInterviewers,
    "hiring-dashboard-jobs": frHdJobs,
    "hiring-dashboard-metrics": frHdMetrics,
    "hiring-dashboard-nav": frHdNav,
    "hiring-dashboard-schedule": frHdSchedule,
    "hiring-dashboard-tasks": frHdTasks,
    "hiring-dashboard-settings-candidate-portal": frHdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": frHdSettingsGeneral,
    "hiring-dashboard-settings-integrations": frHdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": frHdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": frHdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": frHdSettingsScheduling,
    "hiring-dashboard-settings-tasks": frHdSettingsTasks,
    "hiring-dashboard-settings-templates": frHdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": frHdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": frHdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": frHdSettingsTranslations,
    "hiring-dashboard-ai-assistant": frHdAiAssistant,
  },
  "es-ES": {
    common: esCommon,
    "candidate-portal": esCandidatePortal,
    "hiring-dashboard-account": esHdAccount,
    "hiring-dashboard-candidates": esHdCandidates,
    "hiring-dashboard-common": esHdCommon,
    "hiring-dashboard-filter": esHdFilter,
    "hiring-dashboard-interviewer-portal": esHdInterviewerPortal,
    "hiring-dashboard-interviewers": esHdInterviewers,
    "hiring-dashboard-jobs": esHdJobs,
    "hiring-dashboard-metrics": esHdMetrics,
    "hiring-dashboard-nav": esHdNav,
    "hiring-dashboard-schedule": esHdSchedule,
    "hiring-dashboard-tasks": esHdTasks,
    "hiring-dashboard-settings-candidate-portal": esHdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": esHdSettingsGeneral,
    "hiring-dashboard-settings-integrations": esHdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": esHdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": esHdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": esHdSettingsScheduling,
    "hiring-dashboard-settings-tasks": esHdSettingsTasks,
    "hiring-dashboard-settings-templates": esHdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": esHdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": esHdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": esHdSettingsTranslations,
    "hiring-dashboard-ai-assistant": esHdAiAssistant,
  },
  "de-DE": {
    common: deCommon,
    "candidate-portal": deCandidatePortal,
    "hiring-dashboard-account": deHdAccount,
    "hiring-dashboard-candidates": deHdCandidates,
    "hiring-dashboard-common": deHdCommon,
    "hiring-dashboard-filter": deHdFilter,
    "hiring-dashboard-interviewer-portal": deHdInterviewerPortal,
    "hiring-dashboard-interviewers": deHdInterviewers,
    "hiring-dashboard-jobs": deHdJobs,
    "hiring-dashboard-metrics": deHdMetrics,
    "hiring-dashboard-nav": deHdNav,
    "hiring-dashboard-schedule": deHdSchedule,
    "hiring-dashboard-tasks": deHdTasks,
    "hiring-dashboard-settings-candidate-portal": deHdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": deHdSettingsGeneral,
    "hiring-dashboard-settings-integrations": deHdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": deHdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": deHdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": deHdSettingsScheduling,
    "hiring-dashboard-settings-tasks": deHdSettingsTasks,
    "hiring-dashboard-settings-templates": deHdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": deHdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": deHdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": deHdSettingsTranslations,
    "hiring-dashboard-ai-assistant": deHdAiAssistant,
  },
  "da-DK": {
    common: daDKCommon,
    "candidate-portal": daDKCandidatePortal,
    "hiring-dashboard-account": daDKHdAccount,
    "hiring-dashboard-candidates": daDKHdCandidates,
    "hiring-dashboard-common": daDKHdCommon,
    "hiring-dashboard-filter": daDKHdFilter,
    "hiring-dashboard-interviewer-portal": daDKHdInterviewerPortal,
    "hiring-dashboard-interviewers": daDKHdInterviewers,
    "hiring-dashboard-jobs": daDKHdJobs,
    "hiring-dashboard-metrics": daDKHdMetrics,
    "hiring-dashboard-nav": daDKHdNav,
    "hiring-dashboard-schedule": daDKHdSchedule,
    "hiring-dashboard-tasks": daDKHdTasks,
    "hiring-dashboard-settings-candidate-portal": daDKHdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": daDKHdSettingsGeneral,
    "hiring-dashboard-settings-integrations": daDKHdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": daDKHdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": daDKHdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": daDKHdSettingsScheduling,
    "hiring-dashboard-settings-tasks": daDKHdSettingsTasks,
    "hiring-dashboard-settings-templates": daDKHdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": daDKHdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": daDKHdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": daDKHdSettingsTranslations,
    "hiring-dashboard-ai-assistant": daDKHdAiAssistant,
  },
  "it-IT": {
    common: itCommon,
    "candidate-portal": itCandidatePortal,
    "hiring-dashboard-account": itHdAccount,
    "hiring-dashboard-candidates": itHdCandidates,
    "hiring-dashboard-common": itHdCommon,
    "hiring-dashboard-filter": itHdFilter,
    "hiring-dashboard-interviewer-portal": itHdInterviewerPortal,
    "hiring-dashboard-interviewers": itHdInterviewers,
    "hiring-dashboard-jobs": itHdJobs,
    "hiring-dashboard-metrics": itHdMetrics,
    "hiring-dashboard-nav": itHdNav,
    "hiring-dashboard-schedule": itHdSchedule,
    "hiring-dashboard-tasks": itHdTasks,
    "hiring-dashboard-settings-candidate-portal": itHdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": itHdSettingsGeneral,
    "hiring-dashboard-settings-integrations": itHdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": itHdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": itHdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": itHdSettingsScheduling,
    "hiring-dashboard-settings-tasks": itHdSettingsTasks,
    "hiring-dashboard-settings-templates": itHdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": itHdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": itHdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": itHdSettingsTranslations,
    "hiring-dashboard-ai-assistant": itHdAiAssistant,
  },
  // Asia
  "ja-JP": {
    common: jaCommon,
    "candidate-portal": jaCandidatePortal,
    "hiring-dashboard-account": jaHdAccount,
    "hiring-dashboard-candidates": jaHdCandidates,
    "hiring-dashboard-common": jaHdCommon,
    "hiring-dashboard-filter": jaHdFilter,
    "hiring-dashboard-interviewer-portal": jaHdInterviewerPortal,
    "hiring-dashboard-interviewers": jaHdInterviewers,
    "hiring-dashboard-jobs": jaHdJobs,
    "hiring-dashboard-metrics": jaHdMetrics,
    "hiring-dashboard-nav": jaHdNav,
    "hiring-dashboard-schedule": jaHdSchedule,
    "hiring-dashboard-tasks": jaHdTasks,
    "hiring-dashboard-settings-candidate-portal": jaHdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": jaHdSettingsGeneral,
    "hiring-dashboard-settings-integrations": jaHdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": jaHdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": jaHdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": jaHdSettingsScheduling,
    "hiring-dashboard-settings-tasks": jaHdSettingsTasks,
    "hiring-dashboard-settings-templates": jaHdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": jaHdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": jaHdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": jaHdSettingsTranslations,
    "hiring-dashboard-ai-assistant": jaHdAiAssistant,
  },
  "ko-KR": {
    common: koCommon,
    "candidate-portal": koCandidatePortal,
    "hiring-dashboard-account": koHdAccount,
    "hiring-dashboard-candidates": koHdCandidates,
    "hiring-dashboard-common": koHdCommon,
    "hiring-dashboard-filter": koHdFilter,
    "hiring-dashboard-interviewer-portal": koHdInterviewerPortal,
    "hiring-dashboard-interviewers": koHdInterviewers,
    "hiring-dashboard-jobs": koHdJobs,
    "hiring-dashboard-metrics": koHdMetrics,
    "hiring-dashboard-nav": koHdNav,
    "hiring-dashboard-schedule": koHdSchedule,
    "hiring-dashboard-tasks": koHdTasks,
    "hiring-dashboard-settings-candidate-portal": koHdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": koHdSettingsGeneral,
    "hiring-dashboard-settings-integrations": koHdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": koHdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": koHdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": koHdSettingsScheduling,
    "hiring-dashboard-settings-tasks": koHdSettingsTasks,
    "hiring-dashboard-settings-templates": koHdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": koHdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": koHdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": koHdSettingsTranslations,
    "hiring-dashboard-ai-assistant": koHdAiAssistant,
  },
  "zh-TW": {
    common: zhTWCommon,
    "candidate-portal": zhTWCandidatePortal,
    "hiring-dashboard-account": zhTWHdAccount,
    "hiring-dashboard-candidates": zhTWHdCandidates,
    "hiring-dashboard-common": zhTWHdCommon,
    "hiring-dashboard-filter": zhTWHdFilter,
    "hiring-dashboard-interviewer-portal": zhTWHdInterviewerPortal,
    "hiring-dashboard-interviewers": zhTWHdInterviewers,
    "hiring-dashboard-jobs": zhTWHdJobs,
    "hiring-dashboard-metrics": zhTWHdMetrics,
    "hiring-dashboard-nav": zhTWHdNav,
    "hiring-dashboard-schedule": zhTWHdSchedule,
    "hiring-dashboard-tasks": zhTWHdTasks,
    "hiring-dashboard-settings-candidate-portal": zhTWHdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": zhTWHdSettingsGeneral,
    "hiring-dashboard-settings-integrations": zhTWHdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": zhTWHdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": zhTWHdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": zhTWHdSettingsScheduling,
    "hiring-dashboard-settings-tasks": zhTWHdSettingsTasks,
    "hiring-dashboard-settings-templates": zhTWHdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": zhTWHdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": zhTWHdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": zhTWHdSettingsTranslations,
    "hiring-dashboard-ai-assistant": zhTWHdAiAssistant,
  },
  "zh-CN": {
    common: zhCNCommon,
    "candidate-portal": zhCNCandidatePortal,
    "hiring-dashboard-account": zhCNHdAccount,
    "hiring-dashboard-candidates": zhCNHdCandidates,
    "hiring-dashboard-common": zhCNHdCommon,
    "hiring-dashboard-filter": zhCNHdFilter,
    "hiring-dashboard-interviewer-portal": zhCNHdInterviewerPortal,
    "hiring-dashboard-interviewers": zhCNHdInterviewers,
    "hiring-dashboard-jobs": zhCNHdJobs,
    "hiring-dashboard-metrics": zhCNHdMetrics,
    "hiring-dashboard-nav": zhCNHdNav,
    "hiring-dashboard-schedule": zhCNHdSchedule,
    "hiring-dashboard-tasks": zhCNHdTasks,
    "hiring-dashboard-settings-candidate-portal": zhCNHdSettingsCandidatePortal,
    "hiring-dashboard-settings-general": zhCNHdSettingsGeneral,
    "hiring-dashboard-settings-integrations": zhCNHdSettingsIntegrations,
    "hiring-dashboard-settings-interviewers": zhCNHdSettingsInterviewers,
    "hiring-dashboard-settings-privacy": zhCNHdSettingsPrivacy,
    "hiring-dashboard-settings-scheduling": zhCNHdSettingsScheduling,
    "hiring-dashboard-settings-tasks": zhCNHdSettingsTasks,
    "hiring-dashboard-settings-templates": zhCNHdSettingsTemplates,
    "hiring-dashboard-settings-ai-org": zhCNHdSettingsAiOrg,
    "hiring-dashboard-settings-knowledge-bases": zhCNHdSettingsKnowledgeBases,
    "hiring-dashboard-settings-translations": zhCNHdSettingsTranslations,
    "hiring-dashboard-ai-assistant": zhCNHdAiAssistant,
  },
  // Fun — computed from en-US by stretching vowels
  "en-sloth": {
    common: slothifyNamespace(enUSCommon),
    "candidate-portal": slothifyNamespace(enUSCandidatePortal),
    "hiring-dashboard-account": slothifyNamespace(enUSHdAccount),
    "hiring-dashboard-candidates": slothifyNamespace(enUSHdCandidates),
    "hiring-dashboard-common": slothifyNamespace(enUSHdCommon),
    "hiring-dashboard-dev-tools": slothifyNamespace(enUSHdDevTools),
    "hiring-dashboard-filter": slothifyNamespace(enUSHdFilter),
    "hiring-dashboard-interviewer-portal": slothifyNamespace(enUSHdInterviewerPortal),
    "hiring-dashboard-interviewers": slothifyNamespace(enUSHdInterviewers),
    "hiring-dashboard-jobs": slothifyNamespace(enUSHdJobs),
    "hiring-dashboard-metrics": slothifyNamespace(enUSHdMetrics),
    "hiring-dashboard-nav": slothifyNamespace(enUSHdNav),
    "hiring-dashboard-schedule": slothifyNamespace(enUSHdSchedule),
    "hiring-dashboard-tasks": slothifyNamespace(enUSHdTasks),
    "hiring-dashboard-settings-candidate-portal": slothifyNamespace(enUSHdSettingsCandidatePortal),
    "hiring-dashboard-settings-general": slothifyNamespace(enUSHdSettingsGeneral),
    "hiring-dashboard-settings-integrations": slothifyNamespace(enUSHdSettingsIntegrations),
    "hiring-dashboard-settings-interviewers": slothifyNamespace(enUSHdSettingsInterviewers),
    "hiring-dashboard-settings-privacy": slothifyNamespace(enUSHdSettingsPrivacy),
    "hiring-dashboard-settings-scheduling": slothifyNamespace(enUSHdSettingsScheduling),
    "hiring-dashboard-settings-tasks": slothifyNamespace(enUSHdSettingsTasks),
    "hiring-dashboard-settings-templates": slothifyNamespace(enUSHdSettingsTemplates),
    "hiring-dashboard-settings-ai-org": slothifyNamespace(enUSHdSettingsAiOrg),
    "hiring-dashboard-settings-knowledge-bases": slothifyNamespace(enUSHdSettingsKnowledgeBases),
    "hiring-dashboard-settings-translations": slothifyNamespace(enUSHdSettingsTranslations),
    "hiring-dashboard-ai-assistant": slothifyNamespace(enUSHdAiAssistant),
  },
});
